import { OFFICE_TYPES } from "../dto/Company/CompanySettingsDto";

const officeTypes: Array<OFFICE_TYPES> = [
  "RUSSIAN_OFFICE",
  "BELARUSIAN_OFFICE",
  "CHINESE_OFFICE",
  "TURKISH_OFFICE",
  "KAZAKH_OFFICE",
  "THAI_OFFICE",
  "UAE_OFFICE",
];

export function isOfficeType(value: string | null): value is OFFICE_TYPES {
  return Boolean(value && officeTypes.includes(value as OFFICE_TYPES));
}

export function buildAdminDealPath(id: number, officeType: OFFICE_TYPES, tab?: string) {
  const normalizedTab = tab && tab !== "general" ? tab.replace(/^\/+/, "") : undefined;
  const tabPath = normalizedTab ? `/${normalizedTab}` : "";
  const query = new URLSearchParams({ officeType });

  return `/admin/deals/${id}${tabPath}?${query.toString()}`;
}

export function parseAdminDealPath(href: string) {
  if (!href.startsWith("/admin/deals/")) {
    return undefined;
  }

  const url = new URL(href, window.location.origin);
  const match = url.pathname.match(/^\/admin\/deals\/(\d+)(?:\/([^/]+))?\/?$/);
  const officeType = url.searchParams.get("officeType");

  if (!match || !isOfficeType(officeType)) {
    return undefined;
  }

  const id = Number(match[1]);
  if (!Number.isSafeInteger(id) || id <= 0) {
    return undefined;
  }

  return {
    id,
    officeType,
    tab: match[2],
  };
}
